define('shared/util/dispatchers/retrievers/cmus',['shared/my/cmus'], function(getCMus){
    'use strict';
    return getCMus;
});
